import React from 'react';
import styled from 'styled-components';
import { InputRadioGroup } from '@companycam/slab-web';
import { translate } from 'javascripts/translations/i18n';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import { useSetReminderForm } from './hooks/useSetReminderForm';
import { delayOptions } from './constants';

const StyledInputRadioGroup = styled(InputRadioGroup)`
  input[type='radio'] + label span:first-of-type {
    visibility: hidden;
  }
`;

export type SetReminderModalProps = {
  reminderType: string;
  reminderId: string;
};

// TODO: Update to use slab-web Modal when GalleryContainer is no longer itself a modal
export const SetReminderModal = ({
  onRequestClose,
  reminderType,
  reminderId,
}: {
  onRequestClose: () => void;
  reminderType: string;
  reminderId: string;
}) => {
  const { setValue, getValues, handleSubmit } = useSetReminderForm(
    reminderType,
    reminderId,
  );

  const handleRadioChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setValue('delay', event.target?.value || 0);
    await handleSubmit();
    onRequestClose();
  };

  return (
    <CCModal
      isOpen
      onRequestClose={onRequestClose}
      title={translate('reminders.titleText')}
    >
      <form>
        <StyledInputRadioGroup
          id="reminder-delay"
          label={translate('reminders.titleText')}
          hideLabel
          name="delay"
          selectedValue={getValues('delay')}
          options={delayOptions.map((option) => ({
            label: option.label,
            value: option.value,
          }))}
          onChange={handleRadioChange}
        />
      </form>
    </CCModal>
  );
};
